interface Refresher {
    needRefresh: string[]
}

//  データストア
let _Refresher: Refresher = {
    needRefresh: [],
}
export default _Refresher
